import RegionSerializer from "./RegionSerializer";
import StateSerializer from "./StateSerializer";

export default class StateRegionSerializer {
  static serialize(data) {
    return {
      stateToRegionMappingId: data.stateToRegionMappingId,
      stateId: data.stateId,
      regionId: data.regionId,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified,
      region: RegionSerializer.serialize(data.region),
      state: StateSerializer.serialize(data.state)
    };
  }

  static deSerialize(data) {
    return {
      stateToRegionMappingId: data.stateToRegionMappingId,
      stateId: data.stateId,
      regionId: data.regionId,
      dateCreated: data.dateCreated,
      dateModified: data.dateModified,
      region: RegionSerializer.serialize(data.region),
      state: StateSerializer.serialize(data.state)
    };
  }
}